var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPipeDistributionNetwork(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 50,
    viewBox: "0 0 44 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2677_726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.2051 21.5469C43.2051 27.953 41.6093 32.2614 35.3414 38.0186C35.2242 38.1281 22.0313 49.3538 22.0313 49.3538C22.0313 49.3538 8.78317 37.9378 8.66582 37.8283C3.87284 33.6136 0.865234 27.953 0.865234 21.5469C0.865234 9.85321 10.3454 0.380859 22.0313 0.380859C33.725 0.380859 43.2051 9.85321 43.2051 21.5469Z",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.112 38.9208C31.7946 38.9208 39.6439 31.0714 39.6439 21.3888C39.6439 11.7062 31.7946 3.85693 22.112 3.85693C12.4294 3.85693 4.58008 11.7062 4.58008 21.3888C4.58008 31.0714 12.4294 38.9208 22.112 38.9208Z",
    fill: "#5CDAF7",
    stroke: "#FFAA00",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1127 34.765C29.5003 34.765 35.4891 28.7762 35.4891 21.3886C35.4891 14.001 29.5003 8.01221 22.1127 8.01221C14.7251 8.01221 8.73633 14.001 8.73633 21.3886C8.73633 28.7762 14.7251 34.765 22.1127 34.765Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1112 31.4354C27.6599 31.4354 32.158 26.9373 32.158 21.3886C32.158 15.8399 27.6599 11.3418 22.1112 11.3418C16.5626 11.3418 12.0645 15.8399 12.0645 21.3886C12.0645 26.9373 16.5626 31.4354 22.1112 31.4354Z",
    fill: "#5CDAF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.111 26.4569C24.9101 26.4569 27.1791 24.1879 27.1791 21.3889C27.1791 18.5899 24.9101 16.3208 22.111 16.3208C19.312 16.3208 17.043 18.5899 17.043 21.3889C17.043 24.1879 19.312 26.4569 22.111 26.4569Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2677_726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.3399,
    height: 48.9729,
    fill: "white",
    transform: "translate(0.865234 0.380859)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipeDistributionNetwork);
export default __webpack_public_path__ + "static/media/pipe-distribution-network.932b44e5e2d787ad7ef069ae7a4b4a8c.svg";
export { ForwardRef as ReactComponent };